import type { MerchandiseQuote } from '../api/client';

// What the merchant's quantity offers took off an order, as Shopify's checkout lists a discount: by the offer's own
// name ("Pack of 3 −206,59 DH") under a subtotal at full price, so the shopper sees the saving they chose the pack for.

/** One offer's saving, as the checkout's summary lists it. */
export type OfferSaving = { label: string; amount: number };

/** A line as the savings read it: what an offer took off it, and the offer step's name. */
type SavingLine = { discountAmount?: string | number | null; offerLabel?: string | null };

// Adds up each offer's saving across a quote's lines, or an order's, one row per name, leaving out lines no offer touched.
export function offerSavings(source: MerchandiseQuote | readonly SavingLine[] | null, fallback: string): OfferSaving[] {
  const lines: readonly SavingLine[] = Array.isArray(source) ? source : (source as MerchandiseQuote | null)?.lines ?? [];
  const rows = new Map<string, number>();
  for (const line of lines) {
    const amount = Number(line.discountAmount ?? 0);
    if (!(amount > 0)) continue;
    const label = line.offerLabel?.trim() || fallback;
    rows.set(label, Math.round(((rows.get(label) ?? 0) + amount) * 100) / 100);
  }
  return [...rows].map(([label, amount]) => ({ label, amount }));
}
